import PageRenderer from '../../components/PageRenderer/PageRenderer';

function Home() {
  return <PageRenderer pageKey="home" />;
}

export default Home;
